import { toast } from "react-toastify";
import { commonHeader, generateEndpoint } from "~/config/apiConfig";
import { TOAST_MESSAGES } from "~/constants/messages";
import { ErrorBoundary } from "~/errors/errorBoundary";
import type { Credit } from "~/interface/credit";

export type GetPaginatedCreditsListResponse = {
  total_count: number;
  credits: Credit[];
};

export class CreditApi {
  private getRequestInfo(method: string, requestBody?: object): RequestInit {
    return {
      method: method,
      headers: commonHeader,
      credentials: "include",
      keepalive: true,
      ...{
        body: JSON.stringify(requestBody),
      },
    };
  }

  private getRequestBody(baseBody: object, extraBody?: object): object {
    // ベースとなる共通データと、メソッドごとの追加データをマージ
    return { ...baseBody, ...extraBody };
  }

  async getPaginatedCreditsList(
    organization_id: string,
    limit: number = 10,
    page: number = 1,
  ): Promise<GetPaginatedCreditsListResponse | null> {
    const getPaginatedCreditsList = generateEndpoint(
      `/organizations/${organization_id}/credits?limit=${limit}&page=${page}`,
    );

    try {
      const requestInfo = this.getRequestInfo("GET");
      const requestBody = this.getRequestBody(requestInfo);
      const response = await fetch(getPaginatedCreditsList, requestBody);
      if (response.ok) {
        const data: GetPaginatedCreditsListResponse = await response.json();
        return data;
      } else {
        const errorMessage = ErrorBoundary(response.status);
        toast.error(errorMessage);
        return null;
      }
    } catch (_error) {
      toast.error(TOAST_MESSAGES.BILLING.UNEXPECTED_ERROR);
      return null;
    }
  }
}
